// export DsfBaiduMap from './baiduMap.vue';
export const DsfBaiduMap = dsf.defineAsyncComponent('DsfBaiduMap',()=>import(/*webpackChunkName:"platform_form"*/"./baiduMap.vue"));  